import React__default from 'react';
import { Typography } from '@vp/swan';
import { calculateHighlightChunks, EM_TAG_PLACEHOLDER, END_EM_TAG_PLACEHOLDER } from '../../../services/highlightChunksCalculator.js';

var TextWithInverseHighlight = function TextWithInverseHighlight(_ref) {
  var resultText = _ref.resultText;
  if (!resultText) return null;
  if (resultText.indexOf('ais-highlight-0000000000') !== -1) {
    resultText = resultText.replace('ais-highlight-0000000000', 'em');
  }
  if (resultText.indexOf('<em>') === -1) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, resultText);
  var chunks = calculateHighlightChunks(resultText);
  var beginTag = false;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, chunks.map(function (chunk, index) {
    if (chunk === EM_TAG_PLACEHOLDER) {
      beginTag = true;
      return;
    }
    if (chunk === END_EM_TAG_PLACEHOLDER) {
      beginTag = false;
      return;
    }
    if (!beginTag) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        as: "mark",
        fontWeight: "bold",
        backgroundColor: "transparent",
        key: chunk + index,
        color: "standard"
      }, chunk);
    } else {
      return chunk;
    }
  }));
};

export { TextWithInverseHighlight as default };
//# sourceMappingURL=TextWithInverseHighlight.js.map
